/* Imports */
import TeamService from "@/services/team.service.js";
/* /Imports/ */

/* 
  Module: TeamModule
  Description: This module representing different actions with teams.
*/
export const teams = {
    /*
      Self-contained/reusable module.
    */
    namespaced: true,

    /*
      Default states in this module.
    */
    state: {
        teamData: null,
        myTeamsData: null,
    },

    /*
      Define actions for separate different logic. 
    */
    actions: {
        /* 
          Call TeamService class then dispatch all teams action.
        */
        getAllTeams({ commit }) {
            return TeamService.getAllTeams().then(
                (response) => {
                    commit("dataSuccessTeams", response.data.teams);
                    return Promise.resolve(response.data.teams);
                }
            )
        },

        /* 
          Call TeamService class then dispatch user teams action.
        */
        getMyTeams({ commit }, token) {
            return TeamService.getMyTeams(token).then(
                (response) => {
                    commit("dataSuccessMyTeams", response.data.teams);
                    return Promise.resolve(response.data.teams);
                }
            )
        },
    },

    /*
      Define mutations for separate different states. 
    */
    mutations: {
        /* 
          If data for all teams is successfully obtained.
        */
        dataSuccessTeams(state, teamData) {
            state.teamData = teamData;
        },

        /* 
          If data for user teams is successfully obtained.
        */
        dataSuccessMyTeams(state, teamData) {
            state.myTeamsData = teamData;
        },
    }
};
